module.exports = __webpack_public_path__ + "static/img/anos_70.4e7947d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_70.png
// module id = CrnA
// module chunks = 0